<div id="heatmap">
	<div class="flex">
		<div #weekdayLabels class="shrink-0" data-cy="heatmap-weekday-labels"></div>
		<div #chart class="min-w-0 overflow-x-auto" data-cy="heatmap-days"></div>
	</div>

	<div #legend class="overflow-x-auto" data-cy="heatmap-legend"></div>

	<ui-tooltip
		[caretX]="toolTipConfig().left"
		[caretY]="toolTipConfig().top"
		[tooltip]="toolTipConfig().tooltip"
		[visible]="toolTipConfig().visible"
	></ui-tooltip>
</div>
